
import React, { FC, useEffect, useState } from "../../../lib/teact/teact";
import { DBManager } from "../db/dbManager";
import ThuDaiItem from "./thuDaiItem";

type OwerProp = {
    tinhId: string;
    mienDaiCuocId: number;
    onDataChange: (fieldName: string, value: any) => void;
    forceUpdate: () => void;
    trigger:string;
}
/**
 * Do lỗi : nếu sử dụng ThuDaiItem trong UserDaiConfig sẽ không render khi đổi miền đài cược 2,3
 * vì  vậy tách ra thành 2 component riêng cho miền nam và miền trung, trong mỗi component sử dụng
 * ThuDaiItem riêng rẽ thì lại render được, chưa hiểu nguyên nhân,
 * Làm component này sau đó sử dụng ThuDaiItem thì OK
 * có thể nguyên nhân là: phải render lại component cha tức là component này chứa ThuDaiItem
*/
const DaiMienTrongConfig: FC<OwerProp> = ({
    tinhId,
    mienDaiCuocId,
    onDataChange,
    forceUpdate,
    trigger,
}) => {
    const [state, setState] = useState({
        data: [],
    })
    function readData(): Promise<any> {
        return new Promise((resolve, reject) => {
            DBManager.getDBConnection().then((db) => {
                const transaction = db.transaction(["userDaiConfig"], "readwrite");
                const objectStore = transaction.objectStore("userDaiConfig");
                const data: any[] = [];
                [2, 3, 4, 5, 6, 7, 1].map((thu) => {
                    const get = objectStore.get([tinhId, thu])
                    get.onsuccess = () => {
                        data.push(get.result)
                    }
                })
                transaction.oncomplete = () => {
                    resolve(data)
                }
            })
        })
    }
    useEffect(() => {
        readData().then(data => {
            setState(prev => ({ ...prev, data: data }))
            console.log(data)
        })
    }, [tinhId, mienDaiCuocId])
    function handleDataChange(fieldName: string, data: any){
        DBManager.getDBConnection().then(db => {
            const object = db.transaction("userDaiConfig", "readwrite")
                .objectStore("userDaiConfig")
            const get = object.get([tinhId, data.thu])
            get.onsuccess = () => {
                const result = get.result;
                if (mienDaiCuocId == 3) {
                    result.daiMn1 = data.dai1
                    result.daiMn2 = data.dai2
                    result.daiMn3 = data.dai3
                    result.daiMn4 = data.dai4
                } else {
                    result.daiMt1 = data.dai1
                    result.daiMt2 = data.dai2
                    result.daiMt3 = data.dai3
                    result.daiMt4 = data.dai4
                }
                const update = object.put(result)
            }
        })
        onDataChange(fieldName,data)
    }
    return (
        <div className=" thu-dai-main-content" >
            <div className="thu-dai-item">
                <div className=" thu-dai-title"></div>
                <div className=" thu-dai-title">
                    Dch
                </div>
                <div className=" thu-dai-title">
                    Dph1
                </div>
                <div className=" thu-dai-title">
                    Dph2
                </div>
                <div className=" thu-dai-title">
                    Dph3
                </div>
            </div>
            {
                state.data.map((item) => {
                    return <ThuDaiItem
                        onDataChange={handleDataChange}
                        thu={item.thu}
                        tinhId={tinhId}
                        key={tinhId + mienDaiCuocId + item.thu}
                        mienDaiCuoc={mienDaiCuocId}
                        forceUpdate={forceUpdate}
                        dai1={mienDaiCuocId == 3 ? item.daiMn1 : item.daiMt1}
                        dai2={mienDaiCuocId == 3 ? item.daiMn2 : item.daiMt2}
                        dai3={mienDaiCuocId == 3 ? item.daiMn3 : item.daiMt3}
                        dai4={mienDaiCuocId == 3 ? item.daiMn4 : item.daiMt4}
                        trigger={trigger}
                    />

                })

            }
        </div>
    )
}
export default DaiMienTrongConfig;